/**
 * Normaliza a resposta de `cliente/portal/get/statusobra/{empId}/{statusId}`.
 *
 * O endpoint responde em dois formatos:
 *   - `{ statusAtual, fotosRecentes }` na carga inicial (statusId = 0)
 *   - o próprio registro, em formato plano, quando um mês é escolhido no dropdown
 *
 * `fotosRecentes` é o último registro QUE POSSUI FOTOS, e não necessariamente o
 * mês do status exibido — foi daí que veio a divergência de exibir porcentagens
 * de um mês com fotos de outro. As fotos saem sempre do registro exibido.
 */
export function normalizarStatus (payload) {
  const status = (payload && payload.statusAtual) || payload || {}
  const fotos = (status.fotos || []).filter(item => item && item.foto)

  return { status, fotos }
}
